module.exports = __webpack_public_path__ + "img/vking-figma-logo.71472c54.png";